import { render, staticRenderFns } from "./Symptom.vue?vue&type=template&id=57d2497b&scoped=true"
import script from "./Symptom.vue?vue&type=script&lang=js"
export * from "./Symptom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2497b",
  null
  
)

export default component.exports